"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2948],{

/***/ 932948:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(626042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(269396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(785893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(667294);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(225617);
/* harmony import */ var _components_DesignSystem_AtomicComponents_util__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(452388);
/* harmony import */ var src_redux_actions__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(731024);
/* harmony import */ var src_redux_actions__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(96031);
/* harmony import */ var src_redux_actions__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(666162);
/* harmony import */ var _Common_Modal__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(672651);
/* harmony import */ var _utils_mutateVariantItemWithCartData__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(759186);









var VariantChooseRepeatModal = function(props) {
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13;
    var dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useDispatch */ .I0)();
    var ref14 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)({
        repeatIndex: null,
        theme: null
    }), state = ref14[0], setState = ref14[1];
    var ref15 = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useSelector */ .v9)(function(state) {
        return state.commonReducer;
    }), chooseRepeatModal = ref15.variant.chooseRepeatModal, productLoaderId = ref15.productLoaderId;
    var cartData = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useSelector */ .v9)(function(state) {
        return state.cartReducer;
    });
    var ref16 = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useSelector */ .v9)(function(state) {
        return state.storeReducer.store;
    }), theme = ref16.theme, store_id = ref16.store_id;
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if (chooseRepeatModal) {
            var productIndex = cartData.items.findIndex(function(el) {
                return el.id === productLoaderId;
            });
            setState(function(state) {
                return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, state), {
                    repeatIndex: productIndex
                });
            });
        }
    }, [
        chooseRepeatModal,
        cartData,
        productLoaderId
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if (chooseRepeatModal) {
            setState(function(state) {
                return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, state), {
                    theme: theme
                });
            });
        }
    }, [
        chooseRepeatModal,
        theme
    ]);
    var onClose = function() {
        dispatch((0,src_redux_actions__WEBPACK_IMPORTED_MODULE_7__/* .setChooseAndRepeatModalVisibility */ .uT)(false));
    };
    var onIWillChooseBtnHandle = function() {
        /** get the details item for this item id */ dispatch((0,src_redux_actions__WEBPACK_IMPORTED_MODULE_8__/* .fetchCatalogItemById */ .eP)({
            store_id: store_id,
            item_id: productLoaderId,
            src: "variant_choose_repeat_modal"
        }, true));
        onClose();
    };
    var onRepeatBtnHandle = function() {
        var ref, ref1, ref2, ref3, ref4, ref5;
        var newCart = (0,_utils_mutateVariantItemWithCartData__WEBPACK_IMPORTED_MODULE_4__/* .mutateVariantItemWithCartData */ .I)("repeat", cartData === null || cartData === void 0 ? void 0 : (ref = cartData.items) === null || ref === void 0 ? void 0 : ref[state.repeatIndex], cartData === null || cartData === void 0 ? void 0 : (ref1 = cartData.items) === null || ref1 === void 0 ? void 0 : (ref2 = ref1[state.repeatIndex]) === null || ref2 === void 0 ? void 0 : ref2.variants_selected[(cartData === null || cartData === void 0 ? void 0 : (ref3 = cartData.items) === null || ref3 === void 0 ? void 0 : (ref4 = ref3[state.repeatIndex]) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.variants_selected) === null || ref5 === void 0 ? void 0 : ref5.length) - 1], cartData);
        dispatch((0,src_redux_actions__WEBPACK_IMPORTED_MODULE_9__/* .saveCart */ .FP)(newCart));
        onClose();
    };
    return chooseRepeatModal && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_Common_Modal__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
        visible: chooseRepeatModal,
        customStyles: {
            paddingLeft: 0,
            paddingRight: 0
        },
        height: "auto",
        animation: "slideUp",
        className: "bottom-modal variantChooseRepeatModal",
        onClose: onClose,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                className: "closeicon",
                onClick: onClose,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                    loading: "lazy",
                    src: "https://cdn.dotpe.in/longtail/themes/8073865/9sE359Sh.webp",
                    alt: "cancel"
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "title",
                children: "Choose a Variant"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "sub-title",
                children: "Your Last Choice"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("article", {
                className: "variant-name",
                children: (ref5 = cartData === null || cartData === void 0 ? void 0 : (ref = cartData.items) === null || ref === void 0 ? void 0 : (ref1 = ref[state.repeatIndex]) === null || ref1 === void 0 ? void 0 : ref1.variants_selected[(cartData === null || cartData === void 0 ? void 0 : (ref2 = cartData.items) === null || ref2 === void 0 ? void 0 : (ref3 = ref2[state.repeatIndex]) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.variants_selected) === null || ref4 === void 0 ? void 0 : ref4.length) - 1]) === null || ref5 === void 0 ? void 0 : ref5.variant_name
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("section", {
                className: "footer",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                        className: "choose_btn pointer",
                        style: {
                            borderRadius: "".concat(state.theme ? "".concat((0,_components_DesignSystem_AtomicComponents_util__WEBPACK_IMPORTED_MODULE_10__/* .roundnessCalculator */ .M)((ref6 = state.theme) === null || ref6 === void 0 ? void 0 : ref6.roundness)) : "8px"),
                            borderColor: "".concat(state.theme ? (ref7 = state.theme) === null || ref7 === void 0 ? void 0 : (ref8 = ref7.colors) === null || ref8 === void 0 ? void 0 : ref8.primary_color : "#EA5151"),
                            color: "".concat(state.theme ? (ref9 = state.theme) === null || ref9 === void 0 ? void 0 : (ref10 = ref9.colors) === null || ref10 === void 0 ? void 0 : ref10.primary_color : "#EA5151")
                        },
                        onClick: onIWillChooseBtnHandle,
                        children: "I’LL CHOOSE"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                        className: "repeat_btn pointer",
                        style: {
                            backgroundColor: "".concat(state.theme ? (ref11 = state.theme) === null || ref11 === void 0 ? void 0 : (ref12 = ref11.colors) === null || ref12 === void 0 ? void 0 : ref12.primary_color : "#EA5151"),
                            borderRadius: "".concat(state.theme ? "".concat((0,_components_DesignSystem_AtomicComponents_util__WEBPACK_IMPORTED_MODULE_10__/* .roundnessCalculator */ .M)((ref13 = state.theme) === null || ref13 === void 0 ? void 0 : ref13.roundness)) : "8px"),
                            color: "#ffffff"
                        },
                        onClick: onRepeatBtnHandle,
                        children: "REPEAT"
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["default"] = (VariantChooseRepeatModal);


/***/ })

}]);